export default __webpack_public_path__ + "static/media/supermarket.a7b828ea.png";